import api from './client'

export const authApi = {
  login:    (phone, password) => api.post('/auth/login', { phone, password }),
  register: (data)            => api.post('/auth/register', data),
  refresh:  ()                => api.post('/auth/refresh'),
  me:       ()                => api.get('/auth/me'),
  logout:   ()                => api.post('/auth/logout'),
}

export const usersApi = {
  step1:           (data)     => api.patch('/users/me/step1', data),
  step2:           (data)     => api.patch('/users/me/step2', data),
  uploadDocuments: (formData) => api.post('/users/me/documents', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  submit: () => api.post('/users/me/submit'),
  status: () => api.get('/users/me/status'),
}

export const carsApi = {
  // Public
  available: ()    => api.get('/cars/available'),
  getOne:    (id)  => api.get(`/cars/${id}`),

  // Admin
  adminList:   (params)       => api.get('/admin/cars', { params }),
  adminGet:    (id)           => api.get(`/admin/cars/${id}`),
  adminCreate: (data)         => api.post('/admin/cars', data),
  adminUpdate: (id, data)     => api.patch(`/admin/cars/${id}`, data),
  adminDelete: (id)           => api.delete(`/admin/cars/${id}`),
  adminPhoto:  (id, fd)       => api.post(`/admin/cars/${id}/photo`, fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  adminUploadDoc: (id, fd)    => api.post(`/admin/cars/${id}/documents`, fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  adminDeleteDoc: (carId, docId) => api.delete(`/admin/cars/${carId}/documents/${docId}`),
}

export const adminApi = {
  // Users
  listUsers:   (params)      => api.get('/admin/users', { params }),
  getUser:     (id)          => api.get(`/admin/users/${id}`),
  approveUser: (id, comment) => api.post(`/admin/users/${id}/approve`, { comment }),
  rejectUser:  (id, comment) => api.post(`/admin/users/${id}/reject`,  { comment }),
  blockUser:   (id, reason)  => api.post(`/admin/users/${id}/block`,   { reason }),
  unblockUser: (id)          => api.post(`/admin/users/${id}/unblock`),
  changeRole:  (id, role)    => api.patch(`/admin/users/${id}/role`,    { role }),

  // Dashboard
  stats:     () => api.get('/admin/stats'),
  reminders: () => api.get('/admin/reminders'),
  audit:     (params) => api.get('/admin/audit', { params }),

  // Trips
  listTrips: (params) => api.get('/admin/trips', { params }),
}

export const ticketsApi = {
  // Водитель
  list:        (params)    => api.get('/tickets', { params }),
  get:         (id)        => api.get(`/tickets/${id}`),
  create:      (formData)  => api.post('/tickets', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  reply:       (id, formData) => api.post(`/tickets/${id}/messages`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  close:       (id)        => api.post(`/tickets/${id}/close`),

  // Админ
  adminList:   (params)    => api.get('/admin/tickets', { params }),
  adminGet:    (id)        => api.get(`/admin/tickets/${id}`),
  adminUpdate: (id, data)  => api.patch(`/admin/tickets/${id}`, data),
}

/**
 * Публичная часть регионов — доступна любому авторизованному.
 *
 * Отделена от административной намеренно: раньше это был один объект,
 * и водительское приложение, вызывая regionsApi.list(), затягивало
 * в бандл все административные эндпоинты вместе с маршрутами /admin/*.
 * Один объект = одна единица для tree-shaking.
 */
export const regionsApi = {
  list: () => api.get('/regions'),
}

/** Административная часть регионов. Импортируется только консолью. */
export const regionsAdminApi = {
  list:   ()         => api.get('/admin/regions'),
  get:    (id)       => api.get(`/admin/regions/${id}`),
  create: (data)     => api.post('/admin/regions', data),
  update: (id, data) => api.patch(`/admin/regions/${id}`, data),
  remove: (id)       => api.delete(`/admin/regions/${id}`),

  regionCars:  (regionId)            => api.get(`/admin/regions/${regionId}/cars`),
  regionUsers: (regionId, role = '') =>
    api.get(`/admin/regions/${regionId}/users`, { params: role ? { role } : {} }),
  regionAvailableUsers: (regionId, role = '', q = '') =>
    api.get(`/admin/regions/${regionId}/available-users`, {
      params: { ...(role && { role }), ...(q && { q }) },
    }),

  transferCar: (carId, regionId, reason) =>
    api.post(`/admin/cars/${carId}/transfer`, { region_id: regionId, reason }),
  carHistory:  (carId) => api.get(`/admin/cars/${carId}/region-history`),

  setUserRegions: (userId, regionIds) =>
    api.patch(`/admin/users/${userId}/regions`, { region_ids: regionIds }),
  addUserToRegion: (regionId, userId) =>
    api.post(`/admin/regions/${regionId}/users/${userId}`),
  removeUserFromRegion: (regionId, userId) =>
    api.delete(`/admin/regions/${regionId}/users/${userId}`),
}

export const repairsApi = {
  list:   (carId, status = '') =>
    api.get(`/admin/cars/${carId}/repairs`, { params: status ? { status } : {} }),
  create: (carId, data)   => api.post(`/admin/cars/${carId}/repairs`, data),
  update: (id, data)      => api.patch(`/admin/repairs/${id}`, data),
  close:  (id, carStatus) => api.post(`/admin/repairs/${id}/close`, { car_status: carStatus }),
  delete: (id)            => api.delete(`/admin/repairs/${id}`),
}

export const tasksApi = {
  list:    (params = {})  => api.get('/tasks', { params }),
  // Раскладку по дням делает сервер: граница суток зависит от пояса,
  // и считать её на клиенте значило бы получить два разных календаря.
  calendar: (params = {}) => api.get('/tasks/calendar', { params }),
  get:     (id)           => api.get(`/tasks/${id}`),
  create:  (data)         => api.post('/tasks', data),
  update:  (id, data)     => api.patch(`/tasks/${id}`, data),
  delete:  (id)           => api.delete(`/tasks/${id}`),

  start:    (id) => api.post(`/tasks/${id}/start`),
  review:   (id) => api.post(`/tasks/${id}/review`),
  complete: (id) => api.post(`/tasks/${id}/complete`),
  cancel:   (id) => api.post(`/tasks/${id}/cancel`),
  reopen:   (id) => api.post(`/tasks/${id}/reopen`),

  addApprover:    (id, userId) => api.post(`/tasks/${id}/approvers`, { user_id: userId }),
  removeApprover: (id, aid)    => api.delete(`/tasks/${id}/approvers/${aid}`),
  decideApprover: (id, aid, status, comment = '') =>
    api.post(`/tasks/${id}/approvers/${aid}/decide`, { status, comment }),

  comments:   (id)        => api.get(`/tasks/${id}/comments`),
  addComment: (id, formData) =>
    api.post(`/tasks/${id}/comments`, formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }),

  searchUsers: (q = '', role = '', limit = 10) =>
    api.get('/tasks/users/search', { params: { q, role, limit } }),
}

export const logsApi = {
  list:    (stream, params)  => api.get(`/admin/logs/${stream}`, { params }),
  session: (sessionId)       => api.get(`/admin/logs/session/${sessionId}`),
  filters: ()                => api.get('/admin/logs/meta/filters'),
  // Ссылка на выгрузку: браузер скачивает сам, минуя axios.
  exportUrl: (stream, params) => {
    const qs = new URLSearchParams(
      Object.entries(params || {}).filter(([, v]) => v)
    ).toString()
    return `/api/admin/logs/${stream}/export${qs ? `?${qs}` : ''}`
  },
}

/**
 * Правовые документы: соглашение и политика конфиденциальности.
 *
 * Чтение публичное — текст согласия рисуется на экране входа, то есть
 * до появления токена. Запись отделена в settingsAdminApi, чтобы
 * водительский бандл не тянул административный эндпоинт.
 */
export const legalApi = {
  get: () => api.get('/settings/legal'),
  // Текст документа едет отдельно: полотно соглашения на экране
  // входа не нужно, а прочитать его пользователь может по клику.
  getDocument: (key) => api.get(`/settings/legal/document/${key}`),
}

/** Настройки владельца. Импортируется только консолью. */
export const settingsAdminApi = {
  getLegal:  ()     => api.get('/admin/settings/legal'),
  saveLegal: (data) => api.put('/admin/settings/legal', data),
}
